import gql from 'graphql-tag';

const GET_VIDEO_DATA = gql`
  query MyStageVideo($input: MyStageVideoInput!) {
    mystage_video(input: $input) {
      video_type
      video_url
      video_label
      video_subscription_url
    }
  }
`;

const GET_VIDEO_DATA_MSB = gql`
  query MyStageVideo($input: VideoLessonInput!) {
    videoLesson(input: $input) {
      video_type
      video_url
      video_label
      video_subscription_url
    }
  }
`;

export { GET_VIDEO_DATA, GET_VIDEO_DATA_MSB };
